import { Injectable,Injector } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http'
import * as CryptoJS from 'crypto-js';
import {en} from '../environments/environment.tok'
import {en as enk} from '../environments/environments.k'
import { catchError, Observable, throwError } from 'rxjs';
import { SpinnerService } from './shared/spinner.service';
import Swal from 'sweetalert2';
import { Router,NavigationStart, NavigationEnd  } from '@angular/router';
import { session } from '../environments/environment.session'
@Injectable({
  providedIn: 'root'
})
export class TokenInterCepterService {

  constructor(private _router: Router,private injector:Injector, private tspinner:SpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let tokenizedReq=req.clone({
      setHeaders:{
        1000:`bearer ${sessionStorage.getItem('1000')}`,
        1001:`${sessionStorage.getItem('1001')}`,
        1002:`${this.encryptUsingAES256(en.token)}`,
        1003:`${en.session}`,
        1005:`${sessionStorage.getItem('1005')}`,
        'X-XSS-Protection': '1; mode=block'
      }
    })
    return next.handle(tokenizedReq)
    .pipe(
      catchError((error: HttpErrorResponse) => {
        this.tspinner.hide()
        switch (error.status) {
          case 400:
            console.warn('Bad Request (400):', error.error);
            Swal.fire('Info','Currently service is unavailable ,please try after some time','info')
            break;

          case 401:
            console.warn('Unauthorized (401):', error.error);
            sessionStorage.removeItem("1001");
            sessionStorage.removeItem("1000");
            sessionStorage.removeItem("1005");
            session.erpUser = undefined
            this._router.navigate(['/login']);
            break;

          case 404:
            console.warn('Not Found (404):', error.error);
            Swal.fire('Info','The requested resource was not found.','info')
            break;

          case 408:
            console.warn('Request Timeout (408):', error.error);
            Swal.fire('Error...', 'Something went wrong. Please try again later.', 'error')
            break;

          case 429:
            console.warn('Too Many Requests (429):', error.error);
            Swal.fire('Error...', 'Something went wrong. Please try again later.', 'error')
            break;

          case 500:
            console.error('Internal Server Error (500):', error.message);
            Swal.fire('Error...', 'Something went wrong. Please try again later.', 'error')
            break;

          case 502:
          case 503:
          case 504:
            console.warn(`Server Unavailable (${error.status}):`, error.error);
            Swal.fire('Error...', 'The server is currently unavailable. Please try again later.', 'error')
            break;

          default:
            console.warn(`Unexpected Error (${error.status}):`, error.error);
            // Swal.fire('Error...', 'Please try After Some time.', 'error')
            break;
        }

        return throwError(() => new Error(error.message));
      })
    );
  }
   encryptUsingAES256(request:any) {
    let _key = CryptoJS.enc.Utf8.parse(enk.jump);
    let _iv = CryptoJS.enc.Utf8.parse(enk.jump);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(request), _key, {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();
  }







}
